import { CheckCircleFilled } from "@ant-design/icons";
import { Divider, Modal, Tag } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const ModalSuccessCreateSchedule = ({ data, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={null}
      open={!!data}
      onCancel={() => onClose(null)}
      footer={null}
      width={460}
      destroyOnHidden
    >
      {/* Header */}
      <div className="flex flex-col items-center gap-2 pb-4 pt-2">
        <CheckCircleFilled className="text-5xl text-green-500" />
        <p className="mb-0 text-lg font-semibold text-neutral-800">
          {data?.isEdit
            ? t("meeting_schedule.successfully_edit_schedule")
            : t("meeting_schedule.successfully_save_schedule")}
        </p>
      </div>

      {/* Date/time block */}
      <div className="mb-4 rounded-lg border border-neutral-200 bg-neutral-50 px-4 py-3 text-center">
        <p className="mb-0.5 text-sm capitalize text-neutral-500">
          {dayjs(data?.date).format("dddd, DD MMM YYYY")}
        </p>
        <p className="mb-0 text-base font-semibold text-neutral-800">
          {t("meeting_management.at")}{" "}
          {dayjs(data?.start_time, "HH:mm:ss").format("HH:mm")} &ndash;{" "}
          {dayjs(data?.end_time, "HH:mm:ss").format("HH:mm")}
        </p>
      </div>

      {/* Contact + group tag */}
      <div className="mb-1 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="mb-0 truncate font-semibold text-neutral-800">
            {data?.contact?.name}
          </p>
          {data?.contact?.email && (
            <p className="mb-0 text-sm text-neutral-500">{data.contact.email}</p>
          )}
          {data?.contact?.phone && (
            <p className="mb-0 text-sm text-neutral-500">{data.contact.phone}</p>
          )}
          {data?.contact?.company && (
            <p className="mb-0 text-sm text-neutral-500">{data.contact.company}</p>
          )}
        </div>
        {data?.schedule_admin_name && (
          <Tag color="#f80" className="m-0 mt-0.5 shrink-0">
            {data.schedule_admin_name}
          </Tag>
        )}
      </div>

      {/* Note */}
      {data?.note && (
        <>
          <Divider className="my-3" />
          <div>
            <p className="mb-1 text-xs font-medium uppercase tracking-wide text-neutral-500">
              {t("meeting_management.description")}
            </p>
            <p className="mb-0 whitespace-pre-line text-sm text-neutral-700">
              {data.note}
            </p>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ModalSuccessCreateSchedule;
